import { render } from "./BoardSubCategory.vue?vue&type=template&id=7dec6525&scoped=true"
import script from "./BoardSubCategory.vue?vue&type=script&lang=js"
export * from "./BoardSubCategory.vue?vue&type=script&lang=js"

import "./BoardSubCategory.vue?vue&type=style&index=0&id=7dec6525&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dec6525"]])

export default __exports__